import { create } from "zustand";

type TabsStore = {
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
}

export const useTabsStore = create<TabsStore>((set) => ({
  activeTabIndex: 0,
  setActiveTabIndex: (index) => set({ activeTabIndex: index }),
}));